import { render, staticRenderFns } from "./PlayerStatsSection.vue?vue&type=template&id=f88ba7a4&scoped=true"
import script from "./PlayerStatsSection.vue?vue&type=script&lang=js"
export * from "./PlayerStatsSection.vue?vue&type=script&lang=js"
import style0 from "./PlayerStatsSection.vue?vue&type=style&index=0&id=f88ba7a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88ba7a4",
  null
  
)

export default component.exports